import React from 'react'
import {FaGithub, FaLink} from "react-icons/fa"
import "../../node_modules/bootstrap/dist/css/bootstrap.css"

const Project = ({title, description, github, stack, url, image, id}) => {
    return (
        <article className="project">
<div className="card mb-3" styleFor="max-width: 540px;">
  <div className="row g-0">
    <div className="col-md-6">
      <img src={`P${id}.jpg`} alt="..." className="project-image"/>
    </div>
    <div className="col-md-6">
      <div className="card-body project-info">
        <h3 className="card-title">{title}</h3>
        <p className="card-text">{description}</p>
        <div className="project-stack">
                    {stack.map((item)=> {
                        return <span key={item.id}>{item.name}</span>
                    })}
                </div>
        <p className="card-text">
            <div className="project-links">
                    <a href={github} target="__blank" className="btn">
                        <FaGithub className="project-icon" />Github
                    </a>
                    <a href={url} target="__blank" className="btn">
                        <FaLink className="project-icon" />Live Demo
                    </a>
                </div>
        </p>
      </div>
    </div>
  </div>
</div>


        </article>
    )
}

export default Project
